<template>
  <el-card>
    <div slot="header">
      <h1>商品列表</h1>
    </div>
    <el-form inline :model="query" class="filter-form">
      <!-- <el-form-item label="商品名称/商品编码">
        <SpecPicker
          v-model="specQuery.sku"
          v-bind:action="specPickerOptions.action"
          v-bind:labelField="specPickerOptions.labelField"
          v-bind:valueField="specPickerOptions.valueField"
          v-bind:keywordField="specPickerOptions.keywordField"
          v-bind:_placeholder="specPickerOptions._placeholder">
        </SpecPicker>
      </el-form-item> -->

      <el-form-item label="商品名称">
        <el-input v-model.trim="query.productName" placeholder="请输入商品名称" clearable @change='queryCollection'></el-input>
      </el-form-item>

      <el-form-item label="商品编码">
        <el-input v-model.trim="specQuery.sku" placeholder="请输入商品编码" clearable @change='queryCollection'></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="queryCollection">查询</el-button>
      </el-form-item>
    </el-form>
    <el-card :key="product.id" v-for="product in collection" class="block">
      <div slot="header">
        <span class="product-name">
          <span v-if="product.category">
            [{{product.category.cateName}}]
          </span>
          {{product.productName}}
        </span>
        <router-link :to="{ name: 'product-edit', params: { id: product.id }}">
          <el-button style="float: right; padding: 3px 0" type="text">
            <i class="el-icon-edit-outline"></i>
            编辑详情
          </el-button>
        </router-link>
      </div>
      <el-row>
        <el-col :key="productSpec.id" v-for="productSpec in product.productSpecs" :span="3" class="spec-item">
          <OverlayOperator>
            <img v-bind:src="productSpec.photo" class="image spec-image">
            <div slot="operator">
              <el-button type="text" style="font-size: 22px" @click="openSpecEditor(productSpec.id)">
                <i class="el-icon-edit-outline"></i>
              </el-button>
            </div>
          </OverlayOperator>
          <div class="spec-name">{{productSpec.specName}}</div>
          <SpecEditor
            :title="getSpecTitle(product, productSpec)"
            :photos="productSpec.photos"
            :visible="productSpec.id == openedSpec"
            @close="closeSpecEditor"
            @save="(photos) => {saveSpecPhoto(product, productSpec, photos)}"
          />
        </el-col>
      </el-row>
    </el-card>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash'

  import OverlayOperator from '@/components/OverlayOperator'
  import SpecEditor from "./SpecEditor";
  import SpecPicker from "@/components/SpecPicker";

  const { mapGetters } = createNamespacedHelpers('products')

  export default {
    data() {
      return {
        openedSpec: null,
        loading: true,
        query: {
        },
        specQuery: {
          sku: ''
        },
        specPickerOptions : {
          action : 'product-specs',
          labelField : '',
          valueField : '',
          keywordField : 'name',
          defaultValue : '',
          _placeholder : '商品名称/商品编码',
        },
        specValues: '',
      }
    },
    components: {
      SpecEditor,
      OverlayOperator,
      SpecPicker
    },
    computed: {
      ...mapGetters(['collection', 'total', 'pagination']), // 映射必要数据
    },
    methods: {
      openSpecEditor(specId) {
        this.openedSpec = specId
      },
      closeSpecEditor() {
        this.openedSpec = null
      },

      async saveSpecPhoto(product, productSpec, photos) {
        let newProduct = { id: product.id }
        let newProductSpecs = _.cloneDeep(product.productSpecs)
        newProductSpecs = newProductSpecs.map((spec) => {
          if (spec.id == productSpec.id) {
            spec.photos = photos
          }
          delete spec.photo
          return spec
        })
        newProduct.productSpecs = newProductSpecs

        try {
          this.loading = true
          await this.$store.dispatch('products/update', newProduct)
        } finally {
          this.loading = false
        }
        this.closeSpecEditor()

        this.queryCollection({pagination: this.pagination})
      },

      getSpecTitle(product, productSpec) {
        return `编辑“${product.productName}（${productSpec.specName}）”的属性`
      },

      async queryCollection({ pagination = {} } = {}) {
        const query = {
          ...this.query,
          productName: this.query.productName ? `%${(this.query.productName).replace(/^\s*|\s*$/g,"")}%` : undefined // 设为模糊搜索
        }

        const specQuery = {
          ...this.specQuery,
          sku: this.specQuery.sku ? (this.specQuery.sku).replace(/^\s*|\s*$/g,"") : undefined
        }

        try {
          this.loading = true
          await this.$store.dispatch('products/collection', { query, relsQuery: { productSpecs: specQuery }, pagination })
        } finally {
          this.loading = false
        }
      }
    },
    mounted() {
      this.queryCollection()
    },
    activated() {
      this.queryCollection()
    }
  }
</script>
<style scoped>
  .image {
    width: 100%;
    display: block;
  }

  .product-name {
    font-size: 16px;
    font-weight: bold;
  }

  .spec-item {
    padding: 10px;
  }

  .spec-name {
    text-align: center;
  }

  .spec-image {
    margin-bottom: 10px;
  }
</style>
